module.exports = __webpack_public_path__ + "img/add-new-filter.709f0b03.png";